// @ts-nocheck
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { selectCustomerDetails } from '../../customers/state/customerSelectors';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Tabs, Tab } from '@material-ui/core';
import { EmptyState, Panel, TabPanel } from '../../../common/components';
import { selectEvents, selectCorrespondence } from '../state/eventSelectors';
import AdobeCampaignService from '../services/AdobeCampaignService';
import EventsTab from './partials/EventsTab';
import LogInfoTab from './partials/LogInfoTab';
import AccessLogsTab from './partials/AccessLogsTab';
import CorrespondenceTab from './partials/CorrespondenceTab';
import EmailsTab from './partials/EmailsTab';

const TabIndex = {
  Events: 0,
  LogInfo: 1,
  AccessLogs: 2,
  Correspondence: 3,
  Emails: 4,
};

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
  },
  content: {
    flex: '1',
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
}));

function EventsPage() {
  const { userId } = useParams();
  const customerDetails = useSelector(selectCustomerDetails);
  const email = customerDetails?.email;
  const [tabIndex, setTabIndex] = useState(TabIndex.Events);
  const [t] = useTranslation();
  const events = useSelector(selectEvents);
  const correspondence = useSelector(selectCorrespondence);
  const { data: emails } = useQuery(
    ['eventEmails', userId, email],
    async () => {
      const { data } = await AdobeCampaignService.fetchCampaignEmails(userId, email);
      return data;
    },
    {
      enabled: !!userId && !!email,
    }
  );
  const classes = useStyles();

  return (
    <Box id="Events-container" className={classes.container}>
      <Panel id="Events-panel" variant="contained">
        {!events ? (
          <EmptyState variant="unavailable" message={t('event.eventsNotAvailable')} />
        ) : (
          <>
            <Tabs
              id="Events-tabs"
              className={classes.tabs}
              data-value={tabIndex}
              value={tabIndex}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              onChange={(_event, index) => setTabIndex(index)}
            >
              <Tab id="Events-eventsTab" label={t('event.events')} data-index={TabIndex.Events} />
              <Tab
                id="Events-logInfoTab"
                label={t('logInfo.logInfo')}
                data-index={TabIndex.LogInfo}
              />
              <Tab
                id="Events-accessLogs"
                label={t('accessLog.accessLogs')}
                data-index={TabIndex.AccessLogs}
              />
              <Tab
                id="Events-correspondence"
                label={t('correspondence.correspondence')}
                data-index={TabIndex.Correspondence}
                disabled={!correspondence}
              />
              <Tab
                id="Events-emails"
                label={t('campaignEmails.campaignEmails')}
                data-index={TabIndex.Emails}
              />
            </Tabs>
            <Box id="Events-tabsContent" className={classes.content}>
              <TabPanel index={TabIndex.Events} currentIndex={tabIndex}>
                <EventsTab data={events.events} />
              </TabPanel>
              <TabPanel index={TabIndex.LogInfo} currentIndex={tabIndex}>
                <LogInfoTab data={events.loginfos} />
              </TabPanel>
              <TabPanel index={TabIndex.AccessLogs} currentIndex={tabIndex}>
                <AccessLogsTab data={events.accesslogs} />
              </TabPanel>
              {correspondence && (
                <TabPanel index={TabIndex.Correspondence} currentIndex={tabIndex}>
                  <CorrespondenceTab data={correspondence} />
                </TabPanel>
              )}
              <TabPanel index={TabIndex.Emails} currentIndex={tabIndex}>
                <EmailsTab data={emails ?? []} />
              </TabPanel>
            </Box>
          </>
        )}
      </Panel>
    </Box>
  );
}

export default EventsPage;
